// Class: openfl.text.TextLineMetrics

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var TextLineMetrics = function(x,width,height,ascent,descent,leading) {
	this.x = x;
	this.width = width;
	this.height = height;
	this.ascent = ascent;
	this.descent = descent;
	this.leading = leading;
}

// Meta

TextLineMetrics.__name__ = "openfl.text.TextLineMetrics";
TextLineMetrics.__isInterface__ = false;
TextLineMetrics.prototype = {
	
};
TextLineMetrics.prototype.__class__ = TextLineMetrics.prototype.constructor = $hxClasses["openfl.text.TextLineMetrics"] = TextLineMetrics;

// Init



// Statics




// Export

exports.default = TextLineMetrics;